// What to tell the user when an AI call does not come back with a draft.
//
// Three outcomes reach the screen and they need different words. No key set is a
// settings task. A call that failed is a retry, and saying "add an API key" for
// one sends the owner to fix something that is not broken. A request the browser
// itself abandoned is neither — it means the wait was longer than the client was
// willing to give, which is a bug here, not on the provider's side.

// The reply carried a source that is not a real generation.
// Returns null when the result is a genuine AI draft.
export function aiFailure(result) {
  if (!result) return null;
  if (result.source === 'template') {
    return 'No AI key is set, so this is the built-in wording. Add AI_API_KEY in Settings for a live draft.';
  }
  if (result.source === 'error') {
    return result.error
      ? `The AI could not answer: ${result.error}.`
      : 'The AI could not answer. Please try again.';
  }
  return null;
}

// The request threw. Axios reports a client-side timeout with no response and
// code ECONNABORTED, which is worth naming — it looks identical to a server
// error otherwise, and the two are fixed in different places.
export function aiRequestError(e, fallback = 'The assistant could not respond') {
  if (e?.code === 'ECONNABORTED' || /timeout/i.test(e?.message || '')) {
    return 'That took longer than the app was willing to wait. Please try again.';
  }
  return e?.response?.data?.detail || fallback;
}
